import React from 'react';
import { Activity, EActivityType } from 'v2/models';
import { LinkCreatedActivityBody } from './components';

type ActiviyBodyComponentProps = {
  activity: Activity;
};

export function ActivityBodyComponent({ activity }: ActiviyBodyComponentProps) {
  switch (activity.type) {
    case EActivityType.link_created:
      return <LinkCreatedActivityBody activity={activity} />;

    default:
      return null;
  }
}
